import { getServicePath, resolveServiceId } from "../services/catalog";

const staticRouteMap = {
  "/": { no: "/no", en: "/en" },
  "/services": { no: "/no/services", en: "/en/services" },
  "/case": { no: "/no/case", en: "/en/case" },
  "/projects": { no: "/no/case", en: "/en/case" },
  "/om": { no: "/no/om", en: "/en/om" },
  "/about": { no: "/no/om", en: "/en/om" },
  "/kontakt": { no: "/no/kontakt", en: "/en/kontakt" },
  "/contact": { no: "/no/kontakt", en: "/en/kontakt" },
  "/book": { no: "/no/book", en: "/en/book" },
  "/personvern": { no: "/no/personvern", en: "/en/personvern" },
  "/privacy": { no: "/no/personvern", en: "/en/personvern" },
  "/produkter": { no: "/no/produkter", en: "/en/products" },
  "/products": { no: "/no/produkter", en: "/en/products" },
};

export function getLanguagePrefix(language) {
  return language === "en" ? "/en" : "/no";
}

export function stripLanguagePrefix(pathname) {
  if (!pathname || pathname === "/") return "/";
  if (pathname === "/no" || pathname === "/en") return "/";
  if (pathname.startsWith("/no/")) return pathname.slice(3);
  if (pathname.startsWith("/en/")) return pathname.slice(3);
  return pathname;
}

export function translatePath(pathname, targetLanguage) {
  const normalizedPath = stripLanguagePrefix(pathname);

  if (staticRouteMap[normalizedPath]) {
    return staticRouteMap[normalizedPath][targetLanguage];
  }

  if (normalizedPath.startsWith("/services/")) {
    const serviceId = resolveServiceId(normalizedPath.replace("/services/", ""));
    return serviceId ? getServicePath(serviceId, targetLanguage) : staticRouteMap["/services"][targetLanguage];
  }

  const possibleServiceId = resolveServiceId(normalizedPath.replace(/^\//, ""));
  if (possibleServiceId) {
    return getServicePath(possibleServiceId, targetLanguage);
  }

  return targetLanguage === "en" ? "/en" : "/no";
}
